import { render } from "./TrainerListView.vue?vue&type=template&id=1ca0d9ee"
import script from "./TrainerListView.vue?vue&type=script&lang=js"
export * from "./TrainerListView.vue?vue&type=script&lang=js"

import "./TrainerListView.vue?vue&type=style&index=0&id=1ca0d9ee&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__